var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ot-tooltip absolute pointer-events-none z-50",class:{
    'opacity-100 ': _vm.show,
    'opacity-0 ': !_vm.show,
  }},[_c('div',{ref:"slot",staticClass:"bg-white border border-secondary text-xs",class:{
      'rounded-full p-1 transform translate-y-px': _vm.rounded,
      'px-4 py-4 rounded-lg': !_vm.rounded,
    }},[_vm._t("default")],2),_c('div',{ref:"arrow",staticClass:"ot-tooltip-arrow"})])
}
var staticRenderFns = []

export { render, staticRenderFns }